
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";
import { LogOut } from "lucide-react";
import AdPanel from "@/components/ads/AdPanel";
import { useLanguage } from "@/hooks/useLanguage";

const SignOut = () => {
  const navigate = useNavigate();
  const { isRTL } = useLanguage();

  useEffect(() => {
    const handleSignOut = async () => {
      try {
        await supabase.auth.signOut();
        // Small delay to show the sign out message
        setTimeout(() => {
          navigate("/auth");
        }, 2000);
      } catch (error) {
        console.error("Error signing out:", error);
        navigate("/auth");
      }
    };

    handleSignOut();
  }, [navigate]);

  return (
    <div className={`min-h-screen bg-gradient-to-br from-gray-900 to-black flex flex-col ${isRTL ? 'rtl' : 'ltr'}`}>
      <AdPanel />
      
      <div className="flex-1 flex items-center justify-center p-4">
        <Card className="max-w-md w-full bg-gray-800 border-gray-700">
          <CardContent className="p-8 text-center">
            <div className="mb-6">
              <LogOut className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-white mb-2">Signing you out...</h1>
              <p className="text-gray-400">
                Thank you for using our app. You'll be redirected to the login page shortly.
              </p>
            </div>
            
            <div className="animate-spin w-8 h-8 border-4 border-pink-500 border-t-transparent rounded-full mx-auto" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SignOut;
